// extracted by mini-css-extract-plugin
module.exports = {"title":"title___NqmYb","feature":"feature___1WvaS"};